<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '@/lib/utils'
import { useVModel } from '@vueuse/core'

const props = defineProps<{
  defaultValue?: string | number
  modelValue?: string | number
  class?: HTMLAttributes['class']
}>()

const emits = defineEmits<{
  (e: 'update:modelValue', payload: string | number): void
}>()

const inputRef = ref<HTMLInputElement | null>(null)

defineExpose({
  inputRef
})

const modelValue = useVModel(props, 'modelValue', emits, {
  passive: true,
  defaultValue: props.defaultValue
})

const handleInput = (event: Event) => {
  const target = event.target as HTMLInputElement
  if (target.type === 'number') {
    const value = +target.value
    if (value > 99999999) {
      target.value = '99999999'
      modelValue.value = '99999999'
    }
  }
}
</script>

<template>
  <input
    v-bind="$attrs"
    ref="inputRef"
    v-model="modelValue"
    :class="
      cn(
        'flex h-9 w-full rounded-md border bg-white px-3 py-2 ring-offset-white file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-gray-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-600 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 aria-[invalid=true]:border-red-200 aria-[invalid=true]:bg-red-50 aria-[invalid=true]:focus-visible:ring-red-500',
        props.class
      )
    "
    @input="handleInput"
  />
</template>
